module.exports = __webpack_public_path__ + "static/media/utensilsCleaning.b090424c.png";